import { render, staticRenderFns } from "./registration-segment-region.page.vue?vue&type=template&id=679415c0"
import script from "./registration-segment-region.page.vue?vue&type=script&lang=ts"
export * from "./registration-segment-region.page.vue?vue&type=script&lang=ts"
import style0 from "./registration-segment-region.page.vue?vue&type=style&index=0&id=679415c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports